export default "__VITE_ASSET__BfHKYRbH__"